<template>
  <div class="PaymentWay">
    <!-- main -->
    <div class="main">
      <!-- right -->
      <div class="main-right">
        <!-- tit -->
        <div class="main-icon">
          <div class="main-icon-a">
            <i :class="iconComes"
               style="border-radius: 50%;font-size: 20px;padding: 6px;margin-left: 8px;background-color: #5a5a5a;color: #fff;"></i>
            <span style="font-size: 12px;font-weight:bold;margin-left: 12px;color: #606266;">{{ CatalogueName }}</span>
          </div>
          <!-- btn1 -->
          <div class="main-icon-b">
            <span style="font-size: 12px;color: #606266;font-weight: bold;">状态：</span>
            <el-dropdown @command="handleCommand" trigger="click">
              <span class="el-dropdown-link" style="font-size: 12px;color: #606266;font-weight: bold;">
                {{ DropDownedName }}<i class="el-icon-down"></i>
              </span>
              <el-dropdown-menu slot="dropdown" class="status-dropdown">
                <el-dropdown-item command="a">可用</el-dropdown-item>
                <el-dropdown-item command="b">禁用</el-dropdown-item>
                <el-dropdown-item command="c" divided>全部</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <!-- 按钮栏 -->
          <div class="main-icon-c">
            <span style="font-size: 12px;color: #606266;font-weight: bold;display: inline-block;width: 68px;">关键字：</span>
            <el-input size="mini" placeholder="输入名称进行搜索" v-model="searchValue" @keyup.enter.native="handClick(0)"></el-input>
          </div>
          <!-- 按钮栏 -->
          <div class="main-icon-c">
            <el-button v-for="(v,i) in headerBtn" :key="i" :type="v.type" :loading="loading" :icon="v.icon" size="mini"
                       @click="handClick(i)">{{ v.title }}
            </el-button>
          </div>
        </div>
        <!-- table -->
        <div class="table">
          <el-table :data="tableData" border @row-dblclick="handledbRow">
            <el-table-column v-for="(col, inx) in tableRows" :key="inx" :type="col.type"
                             :prop="col.prop" :label="col.name" align="center"
                             :render-header="labelHead"
                             :min-width="getColumnWidth(col.label,col.prop,tableData)">
              <template #default="{ row }">
                {{ safeGetMappedValue(col, row) }}
              </template>
            </el-table-column>
            <el-table-column fixed="left" label="行号" type="index"></el-table-column>
            <el-table-column fixed="right" label="操作" width='158'>
              <template slot-scope="scope">
                <div class="editbox" style="text-align: center;">
                  <el-button type="primary" @click="handleClickEdit(scope.row)" size="mini">编辑</el-button>
                  <el-button :type="scope.row.status === 1 ? 'danger' : 'success'"
                             @click="handleStartOrDisabled(scope.row)" size="mini">
                    {{ scope.row.status === 1 ? '禁用' : '启用' }}
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 分页 -->
        <el-pagination
            class="fixed-pagination"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[8, 16, 24]"
            :page-size="pageSize"
            :total="totalSize"
            layout="total, sizes, prev, pager, next, jumper"
            background>
        </el-pagination>
      </div>
    </div>

    <!-- 新增支付方式表单 -->
    <el-dialog title="新增支付方式" :visible.sync="addDialogVisible" width="50%" :before-close="handleClose"
               :close-on-click-modal="false" class="compact-form">
      <el-form :model="addForm" label-width="120px" size="mini" :rules="formRules" ref="addFormRef" >
        <el-row :gutter="20">
          <!-- 支付方式名称 -->
          <el-col :span="8">
            <el-form-item prop="wayName" label="支付方式:">
              <el-input v-model="addForm.wayName" placeholder="请输入支付方式名称" @input="handleNameInput"></el-input>
            </el-form-item>
          </el-col>

          <!-- 支付方式代码 -->
          <el-col :span="8">
            <el-form-item prop="wayCode" label="支付代码:">
              <el-input v-model="addForm.wayCode" placeholder="请输入支付代码" disabled @input="handleCodeInput"></el-input>
            </el-form-item>
          </el-col>

          <!-- 有效状态 -->
          <el-col :span="8">
            <el-form-item prop="status" label="有效状态:">
              <el-select v-model="addForm.status" placeholder="请选择">
                <el-option v-for="item in statusOptions" :key="item.id" :label="item.label" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <!-- 财务分类 - 级联选择器 -->
          <el-col :span="16">
            <el-form-item prop="classId" label="财务分类:">
              <el-cascader
                  v-model="addForm.classPath"
                  :options="financeClassTree"
                  :props="cascaderProps"
                  placeholder="请选择财务分类"
                  filterable
                  clearable
                  @change="handleClassChange"
                  style="width: 100%">
              </el-cascader>
            </el-form-item>
          </el-col>

          <!-- 财务分类编码 - 新增字段 -->
          <el-col :span="8">
            <el-form-item prop="uniCode" label="财务分类编码:">
              <el-input v-model="addForm.uniCode" placeholder="自动获取财务分类编码" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="addPaymentData">确定</el-button>
        <el-button size="mini" @click="handleClose">取消</el-button>
      </div>
    </el-dialog>

    <!-- 修改支付方式表单 -->
    <el-dialog :title="dynamicTitle" :visible.sync="editDialogVisible" width="50%" :before-close="handleClose"
               :close-on-click-modal="false" class="compact-form">
      <el-form :model="editForm" label-width="120px" size="mini" :rules="formRules" ref="editFormRef"
               :disabled="isLookData">
        <el-row :gutter="20">
          <!-- 支付方式名称 -->
          <el-col :span="8">
            <el-form-item prop="wayName" label="支付方式:">
              <el-input v-model="editForm.wayName" placeholder="请输入支付方式名称" @input="handleNameInputForEdit"></el-input>
            </el-form-item>
          </el-col>

          <!-- 支付方式代码 -->
          <el-col :span="8">
            <el-form-item prop="wayCode" label="支付代码:">
              <el-input v-model="editForm.wayCode" placeholder="请输入支付代码" disabled @input="handleCodeInputForEdit"></el-input>
            </el-form-item>
          </el-col>

          <!-- 有效状态 -->
          <el-col :span="8">
            <el-form-item prop="status" label="有效状态:">
              <el-select v-model="editForm.status" placeholder="请选择">
                <el-option v-for="item in statusOptions" :key="item.id" :label="item.label" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <!-- 财务分类 - 级联选择器 -->
          <el-col :span="16">
            <el-form-item prop="classId" label="财务分类:">
              <el-cascader
                  v-model="editForm.classPath"
                  :options="financeClassTree"
                  :props="cascaderProps"
                  placeholder="请选择财务分类"
                  filterable
                  clearable
                  :disabled="isLookData"
                  @change="handleClassChangeEdit"
                  style="width: 100%">
              </el-cascader>
            </el-form-item>
          </el-col>

          <!-- 财务分类编码 - 新增字段 -->
          <el-col :span="8">
            <el-form-item prop="uniCode" label="财务分类编码:">
              <el-input v-model="editForm.uniCode" placeholder="自动获取财务分类编码" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="submitForm" :disabled="isLookData">修改</el-button>
        <el-button size="mini" @click="handleClose">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { pinyin } from "pinyin-pro";
import { withLoading } from "@/untils/loading";
import { getFinanceclassList } from "@/api/clasificacionContable/clasificacionContable";
import { getPatternPaymentPage, addPatternPayment, editPatternPayment, getPatternPaymentById } from "@/api/patternPayment/patternPayment";

export default {
  data() {
    return {
      searchValue: '',
      CatalogueName: '支付方式管理',
      DropDownedName: '全部',
      iconComes: 'el-icon-money',
      loading: false,
      addDialogVisible: false,
      editDialogVisible: false,
      selectedRow: null,
      pageNum: 1,
      pageSize: 8,
      totalSize: 10,
      pageDataState: null,

      // 财务分类树形数据
      financeClassTree: [],
      financeClassOptions: [],

      // 级联选择器配置
      cascaderProps: {
        value: 'id',
        label: 'name',
        children: 'children',
        checkStrictly: false,
        emitPath: true
      },

      // 新增表单
      addForm: {
        wayName: '',
        wayCode: '',
        status: 1,
        classId: null,
        classPath: [],
        uniCode: '' // 新增财务分类编码
      },

      isLookData: false,
      dynamicTitle: '',

      // 编辑表单
      editForm: {
        id: null,
        wayName: '',
        wayCode: '',
        status: 1,
        classId: null,
        classPath: [],
        uniCode: '' // 新增财务分类编码
      },

      formRules: {
        wayName: [{ required: true, message: '请输入支付方式名称', trigger: 'blur' }],
        wayCode: [{ required: true, message: '请输入支付代码', trigger: 'blur' }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }],
        classId: [{ required: true, message: '请选择财务分类', trigger: 'change' }]
      },

      userInfo: [],
      statusOptions: [{ id: 1, label: '有效' }, { id: 0, label: '禁用' }],

      headerBtn: [
        { search: "search", title: "搜索", type: "success" },
        { add: "add", title: "新增", type: "warning" },
      ],

      tableRows: [
        { name: "支付方式", prop: "wayName", type: "" },
        { name: "支付代码", prop: "wayCode", type: "" },
        { name: "财务分类", prop: "className", type: "" , op: "financeClassOptions" },
        { name: "有效状态", prop: "status", type: "", op: "statusOptions" },
/*
        { name: "操作人", prop: "createName", type: "" },
*/
        { name: "新增时间", prop: "createTime", type: "" },
/*
        { name: "修改人", prop: "updateName", type: "" },
*/
        { name: "修改时间", prop: "updateTime", type: "" }
      ],

      tableData: [],
    };
  },

  mounted() {
    this.loadFinanceClassOptions();
    this.loadData();
    this.userInfo = JSON.parse(localStorage.getItem('userInfo')) || {};
  },

  methods: {
    async loadFinanceClassOptions() {
      try {
        const res = await getFinanceclassList({ status: 1 });
        // 兼容两种返回：直接数组 / { code, data }
        const allData = Array.isArray(res) ? res : res.data;

        if (!Array.isArray(allData)) {
          console.error('财务分类接口返回格式不正确:', res);
          return;
        }

        const filteredData = this.filterFinanceClassByRules(allData);

        this.financeClassOptions = filteredData.map(item => ({
          id: item.id,
          label: item.name,
          uniCode: item.uniCode
        }));

        this.financeClassTree = this.buildTree(filteredData);
        console.log('财务分类树:', this.financeClassTree);
      } catch (error) {
        console.error('加载财务分类失败:', error);
      }
    },
// 新增过滤方法
    filterFinanceClassByRules(dataList) {
      const keepIds = new Set();

      // 1. 添加资金账户 id=100，注意这里用字符串
      keepIds.add('100');

      // 2. 查找并添加两个特定 uniCode 的节点
      const unicodeTargets = ['0IDLDSFVK', '083WKMBB7'];
      unicodeTargets.forEach(code => {
        const found = dataList.find(item => item.uniCode === code);
        if (found) keepIds.add(String(found.id));
      });

      // 3. 递归收集 id=100 的所有子孙节点
      const collectDescendants = (parentId) => {
        const children = dataList.filter(
            item => String(item.parentId) === String(parentId)
        );

        for (const child of children) {
          keepIds.add(String(child.id));
          collectDescendants(child.id);
        }
      };

      collectDescendants('100');

      // 过滤数据，只保留 keepIds 中的节点
      return dataList.filter(item => keepIds.has(String(item.id)));
    },
    // 构建树形结构
    buildTree(data) {
      const map = new Map();
      const roots = [];

      // 创建映射，保存完整数据
      data.forEach(item => {
        map.set(item.id, {
          id: item.id,
          name: item.name,
          parentId: item.parentId,
          uniCode: item.uniCode, // 保存编码
          children: []
        });
      });

      // 构建树
      data.forEach(item => {
        const node = map.get(item.id);
        if (String(item.parentId) === '0') {
          roots.push(node);
        } else {
          const parent = map.get(item.parentId);
          if (parent) {
            parent.children.push(node);
          }
        }
      });

      // 过滤掉没有子节点的空children数组
      const cleanTree = (nodes) => {
        nodes.forEach(node => {
          if (node.children && node.children.length === 0) {
            delete node.children;
          } else if (node.children) {
            cleanTree(node.children);
          }
        });
        return nodes;
      };

      return cleanTree(roots);
    },

    // 根据classId查找完整路径
    findClassPath(id, tree, path = []) {
      for (let i = 0; i < tree.length; i++) {
        const node = tree[i];
        const currentPath = [...path, node.id];

        if (node.id === id) {
          return currentPath;
        }

        if (node.children && node.children.length > 0) {
          const result = this.findClassPath(id, node.children, currentPath);
          if (result) {
            return result;
          }
        }
      }
      return null;
    },

    // 根据classId获取财务分类的uniCode
    getClassUniCode(classId) {
      const findUniCode = (tree, id) => {
        for (let i = 0; i < tree.length; i++) {
          const node = tree[i];
          if (node.id === id) {
            return node.uniCode;
          }
          if (node.children && node.children.length > 0) {
            const result = findUniCode(node.children, id);
            if (result) return result;
          }
        }
        return '';
      };
      return findUniCode(this.financeClassTree, classId) || '';
    },

    // 级联选择器变化处理（新增）
    handleClassChange(value) {
      if (value && value.length > 0) {
        // 取最后一个ID作为classId
        const classId = value[value.length - 1];
        this.addForm.classId = classId;
        // 自动获取财务分类编码
        this.addForm.uniCode = this.getClassUniCode(classId);
      } else {
        this.addForm.classId = null;
        this.addForm.uniCode = '';
      }
    },

    // 级联选择器变化处理（编辑）
    handleClassChangeEdit(value) {
      if (value && value.length > 0) {
        const classId = value[value.length - 1];
        this.editForm.classId = classId;
        // 自动获取财务分类编码
        this.editForm.uniCode = this.getClassUniCode(classId);
      } else {
        this.editForm.classId = null;
        this.editForm.uniCode = '';
      }
    },

    // 名称转拼音简码
    handleNameInput() {
      this.addForm.wayCode = pinyin(this.addForm.wayName, {
        pattern: 'first',
        toneType: 'none',
        separator: ''
      }).toLocaleUpperCase();
    },

    handleCodeInput() {
      // 手动输入代码时不做处理
    },

    handleNameInputForEdit() {
      if (!this.isLookData) {
        this.editForm.wayCode = pinyin(this.editForm.wayName, {
          pattern: 'first',
          toneType: 'none',
          separator: ''
        }).toLocaleUpperCase();
      }
    },

    handleCodeInputForEdit() {
      // 手动输入代码时不做处理
    },

    // 关闭对话框
    handleClose() {
      this.addDialogVisible = false;
      this.editDialogVisible = false;
      this.addForm = {
        wayName: '',
        wayCode: '',
        status: 1,
        classId: null,
        classPath: [],
        uniCode: ''
      };
      this.editForm = {
        id: null,
        wayName: '',
        wayCode: '',
        status: 1,
        classId: null,
        classPath: [],
        uniCode: ''
      };
      this.loadData();
    },

    // 编辑
    async handleClickEdit(data) {
      this.dynamicTitle = '编辑';
      this.isLookData = false;

      try {
        const res = await getPatternPaymentById(data.id);
        if (res.code === 200) {
          this.editForm = { ...res.data };
          this.editForm.status = parseInt(this.editForm.status);

          // 根据classId设置级联选择器的路径
          if (this.editForm.classId) {
            const path = this.findClassPath(this.editForm.classId, this.financeClassTree);
            this.editForm.classPath = path || [];
            // 设置财务分类编码
            this.editForm.uniCode = this.editForm.uniCode || this.getClassUniCode(this.editForm.classId);
          }

          this.editDialogVisible = true;
        }
      } catch (error) {
        console.log(error);
        this.$message.error('获取数据失败');
      }
    },

    // 查看详情
    async handledbRow(row) {
      this.dynamicTitle = '查看';
      this.isLookData = true;

      try {
        const res = await getPatternPaymentById(row.id);
        if (res.code === 200) {
          this.editForm = JSON.parse(JSON.stringify(res.data));
          this.editForm.status = parseInt(this.editForm.status);

          // 根据classId设置级联选择器的路径
          if (this.editForm.classId) {
            const path = this.findClassPath(this.editForm.classId, this.financeClassTree);
            this.editForm.classPath = path || [];
            // 设置财务分类编码
            this.editForm.uniCode = this.editForm.uniCode || this.getClassUniCode(this.editForm.classId);
          }

          this.editDialogVisible = true;
        }
      } catch (error) {
        this.$message.error('获取数据失败');
      }
    },

    // 提交表单
    async submitForm() {
      try {
        await this.$refs.editFormRef.validate();
      } catch (error) {
        this.$message.error('请填写完整表单');
        return;
      }
      await this.editPaymentData();
    },

    // 新增支付方式
    async addPaymentData() {
      await withLoading(this, '数据提交中...')(async () => {
        try {
          await this.$refs.addFormRef.validate();
        } catch (error) {
          this.$message.error('请填写完整表单');
          return;
        }

        // 提交时只传classId和uniCode
        const submitData = {
          ...this.addForm,
          classId: this.addForm.classId
        };
        delete submitData.classPath;

        const res = await addPatternPayment(submitData);
        if (res.code === 200) {
          this.addForm = {
            wayName: '',
            wayCode: '',
            status: 1,
            classId: null,
            classPath: [],
            uniCode: ''
          };
          this.$refs.addFormRef.resetFields();
          this.addDialogVisible = false;
          await this.loadData();
          this.$message.success('新增成功');
        } else {
          this.$message.error(res.message);
        }
      });
    },

    // 编辑支付方式
    async editPaymentData() {
      await withLoading(this, '数据提交中...')(async () => {
        // 提交时只传classId
        const submitData = {
          ...this.editForm,
          classId: this.editForm.classId
        };
        delete submitData.classPath;

        const res = await editPatternPayment(submitData);
        if (res.code === 200) {
          this.editForm = {
            id: null,
            wayName: '',
            wayCode: '',
            status: 1,
            classId: null,
            classPath: [],
            uniCode: ''
          };
          this.editDialogVisible = false;
          await this.loadData();
          this.$message.success('修改成功');
        } else {
          this.$message.error(res.message);
        }
      });
    },

    // 启用禁用
    async handleStartOrDisabled(row) {
      const action = row.status === '1' ? '禁用' : '启用';
      this.$confirm(`请确认是否${action}【${row.wayName}】`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        await withLoading(this, `${action}处理中...`)(async () => {
          const res = await getPatternPaymentById(row.id);
          if (res.code === 200) {
            const updateData = { ...res.data };
            updateData.status = row.status === '1' ? '0' : '1';
            const updateRes = await editPatternPayment(updateData);
            if (updateRes.code === 200) {
              await this.loadData();
              this.$message.success(`${action}成功`);
            } else {
              this.$message.error(updateRes.message);
            }
          } else {
            this.$message.error(res.message);
          }
        });
      }).catch(() => {
        this.loadData();
      });
    },

    // 加载数据
    async loadData() {
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        wayName: this.searchValue || '',
        status: this.pageDataState
      };

      try {
        const res = await getPatternPaymentPage(params);
        if (res.code === 200) {
          this.tableData = res.data.content.map(item => ({
            ...item,
            className: this.getFinanceClassName(item.classId)
          }));
          this.pageNum = res.data.pageNum;
          this.pageSize = res.data.pageSize;
          this.totalSize = res.data.totalSize;
        } else {
          this.$message.error(res.message);
        }
      } catch (error) {
        this.$message.error('加载数据失败');
      }
    },

    // 根据classId获取财务分类名称（用于表格显示）
    getFinanceClassName(classId) {
      const findName = (tree, id) => {
        for (let i = 0; i < tree.length; i++) {
          const node = tree[i];
          if (node.id === id) {
            return node.name;
          }
          if (node.children && node.children.length > 0) {
            const result = findName(node.children, id);
            if (result) return result;
          }
        }
        return null;
      };

      const name = findName(this.financeClassTree, classId);
      return name || '';
    },

    // 按钮点击
    handClick(i) {
      switch (i) {
        case 0:
          this.loadData();
          break;
        case 1:
          this.addDialogVisible = true;
          break;
      }
    },

    // 状态筛选
    handleCommand(command) {
      this.pageDataState = command === 'a' ? 1 : command === 'b' ? 0 : command === 'c' ? null : null;
      this.DropDownedName = command === 'a' ? '可用' : command === 'b' ? '禁用' : '全部';
      this.pageNum = 1;
      this.loadData();
    },

    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNum = 1;
      this.loadData();
    },

    handleCurrentChange(val) {
      this.pageNum = val;
      this.loadData();
    },

    // 表格数据映射
    formatColumn(row, prop) {
      const value = row[prop];
      switch (prop) {
        case 'status':
          return this.mapToLabel(value, this.statusOptions);
        default:
          return value;
      }
    },

    mapToLabel(value, options) {
      if (value === undefined || value === null) return '';
      const found = options.find(item => item.id == value);
      return found ? found.label : value;
    },

    safeGetMappedValue(col, row) {
      const rawValue = row[col.prop];
      if (rawValue === null || rawValue === undefined) return ' ';

      const mapArray = this[col.op];
      if (!col.op || !Array.isArray(mapArray)) return rawValue;

      const matched = mapArray.find(item => item.id == rawValue);
      return matched?.label || rawValue;
    },

    // 获取列宽度
    getColumnWidth(label, prop, tableData) {
      if (!tableData || tableData.length === 0) return 120;

      const minWidth = 80;
      const padding = 30;
      const contentList = tableData.map(item => item?.[prop] ?? '');
      const widths = [...contentList, label].map(text => {
        const str = String(text || '');
        return this.getTextWidth(str) + padding;
      });

      return Math.max(minWidth, ...widths);
    },

    // 获取文本宽度
    getTextWidth(text, fontSize = 14) {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      ctx.font = `${fontSize}px Microsoft YaHei`;
      return ctx.measureText(text).width;
    },

    // 表头渲染
    labelHead(h, { column }) {
      const l = column.label.length;
      const f = 12;
      column.minWidth = f * (l + 5);
      return h("div", { class: "table-head", style: { width: "100%" } }, [
        column.label,
      ]);
    }
  }
}
</script>

<style lang="less" scoped>
/* 保持原有样式不变，添加级联选择器样式 */
.status-dropdown .el-dropdown-menu__item {
  font-size: 12px !important;
  color: #606266 !important;
}

.status-dropdown .el-dropdown-menu__item:hover {
  color: #409EFF !important;
  background-color: #f5f7fa !important;
}

.fixed-pagination {
  position: fixed;
  bottom: 20px;
  left: 207px;
  right: 0;
  background: #fff;
  padding: 10px;
  box-shadow: 0 -1px 5px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(100% - 200px);
  margin: 0 auto;
}

.el-dialog {
  min-width: 400px;

  .el-dialog__body {
    padding: 10px 15px !important;
  }

  @media (max-width: 768px) {
    width: 90% !important;
    min-width: unset;
  }
}

.compact-form {
  .el-form-item {
    margin-bottom: 6px !important;
  }

  .el-row {
    margin-bottom: -5px !important;

    .el-col {
      padding-bottom: 5px !important;
    }
  }
}

.dialog-footer {
  padding: 8px 15px !important;
}

.el-table :deep(.current-row) {
  background-color: #000 !important;
}

/deep/ .el-dialog__title {
  font-size: 12px;
  color: #fff;
}

/deep/ .el-dialog__headerbtn {
  top: 12px;
}

/deep/ .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}

/deep/ .el-dialog__header {
  background-color: #39648f;
  padding: 8px;
}

/deep/ .el-dialog__body {
  padding: 0 20px 0 20px;
  border: 1px solid #efefef;
  padding: 8px;
}

/deep/ .el-dropdown-menu__item {
  font-size: 12px;
}

/deep/ .el-table .cell {
  font-size: 12px;
  text-align: center;
}

.PaymentWay {
  height: 100%;
  width: 100%;

  .main {
    width: 100%;
    display: flex;
    justify-content: space-between;

    .main-right {
      flex: 1;
      width: 100%;
      height: 100%;

      .main-icon {
        display: flex;
        align-items: center;
        padding: 12px;
        line-height: 40px;

        .main-icon-b {
          margin-left: 28px;
        }

        .main-icon-c {
          display: flex;
          margin-left: 28px;
        }
      }

      .table {
        padding: 0 12px;
      }
    }
  }
}
</style>